/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Text } from "@cars24/turbo-web/lib/text";
import { Button } from "@cars24/turbo-web/lib/button";
import { BottomSheet } from "@cars24/turbo-web/lib/bottom-sheet";
import VehicleAccordion from "../../mobile/vehicle-accordion";
import BrandList from "../../mobile/vehicle-brand-list-sh";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import Modal from "../modal";
import CloseButton from "../icon-cross";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { vhrEvents, vhrEventNames } from "../../../constants/car-service-history-constants";
import Slider from "@cars24/turbo-web/lib/slider";
import LazyImage from "../lazy-image";

const CarServiceHistorySampleReport = ({
    isDesktop = false,
    vhrCmsData,
    fetchSampleReportUrlConnect,
    fetchVhrCmsDataConnect
}) => {
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

    const { tokens } = useTokens();

    const handleBrandSelection = async ({ id, makeDisplay }) => {
        const response = await fetchSampleReportUrlConnect(id);
        await yieldToMain();
        window.open(response?.data?.documentUrl, "_blank");
        setIsBottomSheetOpen(false);

        await yieldToMain();
        sendCustomGaEvents({
            ...vhrEvents,
            eventAction: vhrEventNames.HOMEPAGE_SAMPLE_REPORT_BRAND_SELECTED,
            eventLabel: makeDisplay
        });
    };

    const onButtonClick = async() => {
        setIsBottomSheetOpen(true);

        await yieldToMain();
        sendCustomGaEvents({...vhrEvents, eventAction: vhrEventNames.HOMEPAGE_SAMPLE_REPORT_CTA_CLICKED});
    };

    const { pageSections = [] } = vhrCmsData || {};
    const details = pageSections[0]?.pageSection;

    useEffect(() => {
        if (
            !vhrCmsData ||
      !vhrCmsData.pageSections ||
      vhrCmsData.pageSections.length === 0
        ) {
            if (fetchVhrCmsDataConnect) {
                fetchVhrCmsDataConnect();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSwipe = async() => {
        await yieldToMain();
        sendCustomGaEvents({...vhrEvents, eventAction: vhrEventNames.SAMPLE_CAROUSEL_SCROLL});
    };

    const getContent = () => {
        return (
                details?.sectionData?.map((item, index) => (
                    <div key={index} styleName="styles.cardWrapper">
                        <div styleName="styles.imageWrapper">
                            {!isDesktop && index !== 0 ? <LazyImage src={item.image.url} alt={item.title} /> :
                                <img src={item.image.url} alt={item.title} />}
                        </div>
                        <div styleName="styles.cardText">
                            <Text size={isDesktop ? "300" : "400"} fontWeight="semibold">
                                {item.title}
                            </Text>
                            <Text size={isDesktop ? "200" : "250"} fontWeight="regular" color="#717272">
                                {item.subTitle}
                            </Text>
                        </div>
                    </div>
                ))
        );
    };

    return (
        <div styleName="styles.wrapper">
            <div styleName="styles.headingWrapper">
                <Text size={isDesktop ? "400" : "300"} fontWeight="semibold" as="h2">
                    {details?.title ||
          "Our vehicle history report covers every hidden detail"}
                </Text>
                {isDesktop ? <div styleName="styles.desktopButtonWrapper">
                    <Button
                        label={details?.ctaText || "View Sample Report"}
                        variant="secondary"
                        size="large"
                        onClick={onButtonClick}
                    />
                </div> : null}
            </div>
            {isDesktop ? <div styleName="styles.desktopCard">{getContent()}</div> :
                <div styleName="styles.mobileWrapper">
                    <div styleName="styles.historyCard">
                        <Slider variant="tertiary"
                            settings={{
                                autoplay: false,
                                loop: true
                            }}
                            gap={14}
                            onSlideChange={handleSwipe}
                        >
                            {getContent()}
                        </Slider>
                    </div>
                    <div styleName="styles.buttonWrapper">
                        <Button
                            label={details?.ctaText || "View Sample Report"}
                            variant="secondary"
                            size="medium"
                            onClick={onButtonClick}
                        />
                    </div>
                </div> }
            {!isDesktop ? <BottomSheet
                isOpen={isBottomSheetOpen}
                onClose={() => setIsBottomSheetOpen(false)}
                overlayColor={tokens.background_surface_overlay_primary}
                height="515px"
            >
                <div>
                    <VehicleAccordion
                        heading={"brand"}
                        ContentComponent={BrandList}
                        isHistory={true}
                        customCallback={handleBrandSelection}
                    />
                </div>
            </BottomSheet> : <Modal isOpen={isBottomSheetOpen} onClose={() => setIsBottomSheetOpen(false)}>
                <div styleName={"styles.modalWrapper"}>
                    <div styleName={"styles.modalButtonWrapper"}>
                        <div styleName={"styles.buttonContainer"}>
                            <CloseButton type={"black"} onClickHandler={() => setIsBottomSheetOpen(false)} height={32} width={32}/>
                        </div>
                    </div>
                    <div styleName={"styles.accordianWrapper"}>
                        <VehicleAccordion
                            heading={"brand"}
                            ContentComponent={BrandList}
                            isHistory={true}
                            customCallback={handleBrandSelection}
                        />
                    </div>
                </div>
            </Modal>}
        </div>
    );
};

CarServiceHistorySampleReport.propTypes = {
    isDesktop: PropTypes.bool,
    vhrCmsData: PropTypes.object,
    fetchSampleReportUrlConnect: PropTypes.func,
    fetchVhrCmsDataConnect: PropTypes.func
};

export default CarServiceHistorySampleReport;
